import * as React from 'react';
import { i18n } from "../../config/i18n";
import { TextInputField } from '../../ap/fields/inputField';
import * as gls from '../../ap/layout/gls';
import * as styles from '../../ap/base/styles';
import { appState } from '../../state/state';

const {voi} = appState;

export const UserNameInputs = (props: {  }) => {
  return (
    <gls.ContentVerticalContentMargined margin={styles.spacing.verticalBetweenFields}>
      <TextInputField id="givenNames" name="givenNames" label={i18n("firstName")} star={true} fieldState={voi.firstName} />
      <gls.ResponsiveGridParent margin={styles.spacing.horizontalBetweenFields}>
        <TextInputField id="middleNames" name="middleNames" label={i18n("middleNames")} fieldState={voi.middleNames} />
        <TextInputField id="surname" name="surname" label={i18n("surname")} star={true} fieldState={voi.surname} />
      </gls.ResponsiveGridParent>
    </gls.ContentVerticalContentMargined>
  );
}
